/**
 * THIS FILE IS AUTOGENERATED
 * Do not edit directly as it will be overwritten by the task that generated it
 */

import { useEffect, useState } from 'react'
import type { BrandThemeIcon } from '@jotta/types/Brand'
import { useBrandCode } from '../../hooks/useBrandTheme'

type IconLoader = () => Promise<{ default: BrandThemeIcon }>

const brandIcons: Record<string, IconLoader> = {
  ONLIME_WL: () =>
    import(
      /* webpackChunkName: "icons-onlime" */ '@jotta/design-system/icons/onlime/Visa.svg'
    ),
  ELGIGANTEN: () =>
    import(
      /* webpackChunkName: "icons-elgiganten" */ '@jotta/design-system/icons/elgiganten/Visa.svg'
    ),
  MEDIAMARKT: () =>
    import(
      /* webpackChunkName: "icons-mediamarkt" */ '@jotta/design-system/icons/mediamarkt/Visa.svg'
    ),
  PHONERO: () =>
    import(
      /* webpackChunkName: "icons-phonero" */ '@jotta/design-system/icons/phonero/Visa.svg'
    ),
  HALEBOP: () =>
    import(
      /* webpackChunkName: "icons-halebop" */ '@jotta/design-system/icons/halebop/Visa.svg'
    ),
  ELKO: () =>
    import(
      /* webpackChunkName: "icons-elko" */ '@jotta/design-system/icons/elko/Visa.svg'
    ),
  TELIA_CLOUD: () =>
    import(
      /* webpackChunkName: "icons-teliacloud" */ '@jotta/design-system/icons/teliacloud/Visa.svg'
    ),
  GIGANTTI: () =>
    import(
      /* webpackChunkName: "icons-gigantti" */ '@jotta/design-system/icons/gigantti/Visa.svg'
    ),
  LETS_GO: () =>
    import(
      /* webpackChunkName: "icons-letsgo" */ '@jotta/design-system/icons/letsgo/Visa.svg'
    ),
  OBOS: () =>
    import(
      /* webpackChunkName: "icons-obos" */ '@jotta/design-system/icons/obos/Visa.svg'
    ),
  TEST: () =>
    import(
      /* webpackChunkName: "icons-test" */ '@jotta/design-system/icons/test/Visa.svg'
    ),
  SATURN: () =>
    import(
      /* webpackChunkName: "icons-saturn" */ '@jotta/design-system/icons/saturn/Visa.svg'
    ),
  ELKJOP: () =>
    import(
      /* webpackChunkName: "icons-elkjop" */ '@jotta/design-system/icons/elkjop/Visa.svg'
    ),
  GET: () =>
    import(
      /* webpackChunkName: "icons-teliasky" */ '@jotta/design-system/icons/teliasky/Visa.svg'
    ),
  TDC_NO: () =>
    import(
      /* webpackChunkName: "icons-tsky" */ '@jotta/design-system/icons/tsky/Visa.svg'
    ),
  COMHEM: () =>
    import(
      /* webpackChunkName: "icons-tele2" */ '@jotta/design-system/icons/tele2/Visa.svg'
    ),
  JOTTACLOUD: () =>
    import(
      /* webpackChunkName: "icons-jottacloud" */ '@jotta/design-system/icons/jottacloud/Visa.svg'
    ),
}

const SvgVisa: BrandThemeIcon = props => {
  const brandCode = useBrandCode()
  const [Icon, setIcon] = useState<BrandThemeIcon | null>(null)

  useEffect(() => {
    let cancelled = false
    setIcon(null)

    const load = brandIcons[brandCode]

    load().then(icon => {
      if (cancelled) return
      setIcon(() => icon.default as BrandThemeIcon)
    })

    return () => {
      cancelled = true
    }
  }, [brandCode])

  if (!Icon) return null
  return <Icon {...props} />
}

export default SvgVisa
